/**
 * CollabPresence — shows avatars of active collaborators + collab status badge.
 */
import React from 'react';
import { Users, Wifi, WifiOff } from 'lucide-react';
import { useEditorStore } from '../stores/editorStore';

export function CollabPresence() {
  const { collabActive, collabUsers } = useEditorStore();

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {/* Status badge */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: 4,
        fontSize: 11, fontWeight: 500,
        color: collabActive ? '#059669' : '#9ca3af',
      }}>
        {collabActive ? <Wifi size={12}/> : <WifiOff size={12}/>}
        {collabActive ? 'Live' : 'Offline'}
      </div>

      {/* User avatars */}
      {collabUsers.length > 0 && (
        <div style={{ display: 'flex', marginLeft: 4 }}>
          {collabUsers.slice(0, 4).map((u, i) => (
            <div
              key={u.socketId}
              title={u.username}
              style={{
                width: 26, height: 26, borderRadius: '50%',
                background: u.color || '#818cf8',
                border: '2px solid #fff',
                marginLeft: i > 0 ? -8 : 0,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 10, fontWeight: 700, color: '#fff',
                zIndex: 4 - i,
              }}
            >
              {(u.username || '?')[0].toUpperCase()}
            </div>
          ))}
          {collabUsers.length > 4 && (
            <div style={{
              width: 26, height: 26, borderRadius: '50%',
              background: 'var(--em-border)', border: '2px solid #fff',
              marginLeft: -8, display: 'flex', alignItems: 'center',
              justifyContent: 'center', fontSize: 10, color: 'var(--em-fg5)', fontWeight: 600,
            }}>
              +{collabUsers.length - 4}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
